module.exports = __webpack_public_path__ + "img/ic_card.173d462e.svg";